import React from 'react';
import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';
import { useLocales } from '@/locales';
import CertificateList from '@/pages/auth/components/EDSAuth/CertificateList';
import PrivacyAgreement from '@/pages/auth/components/EDSAuth/PrivacyAgreement';
import { useEDSAuth } from '@/pages/auth/hooks/useEDSAuth';
import { useCertificates } from '@/pages/auth/hooks/useCertificates';
import { LogIn } from 'lucide-react';

const EDSAuthForm = () => {
  const { translate } = useLocales();

  const {
    certificates,
    selectedIndex,
    isSearchingKey,
    isKeyFound,
    privacyAgreed,
    isAuthenticating,
    canSubmit,
    handleStartSearchingKey,
    handleCertificateSelect,
    handleAuthWithKey,
    setPrivacyAgreed,
  } = useEDSAuth();

  const { stats } = useCertificates(certificates);

  return (
    <div className="space-y-4">
      {stats.total > 0 && (
        <p className="text-sm text-muted-foreground">
          {translate('certificates_found')}: {stats.total}
          {stats.expired > 0 && ` (${stats.expired} ${translate('expired')})`}
        </p>
      )}

      <CertificateList
        certificates={certificates}
        selectedIndex={selectedIndex}
        onCertificateSelect={handleCertificateSelect}
        isKeyFound={isKeyFound}
      />

      <div className="space-y-3">
        {!isKeyFound && (
          <Button
            className="w-full"
            onClick={handleStartSearchingKey}
            disabled={selectedIndex !== null || isSearchingKey}
          >
            {isSearchingKey ? (
              <>
                <Spinner size={16} className="mr-2" />
                {translate('Looking_for_EDS_key')}
              </>
            ) : (
              translate('Find_the_digital_signature_key')
            )}
          </Button>
        )}

        {selectedIndex !== null && isKeyFound && (
          <Button
            className="w-full"
            onClick={handleAuthWithKey}
            disabled={!canSubmit}
          >
            {translate('Login_with_EDS') || 'Login with EDS'}
            <LogIn className="ml-2 h-4 w-4" />
            {isAuthenticating && <Spinner size={16} className="ml-2" />}
          </Button>
        )}
      </div>

      <PrivacyAgreement
        onPrivacyChange={setPrivacyAgreed}
        isVisible={isKeyFound}
        privacyAgreed={privacyAgreed}
      />
    </div>
  );
};

export default EDSAuthForm;
